import React, { useEffect, useState, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    settheTicketraiseroutes,
    getSideBarfilesActions,
    settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions,
} from "../../Redux/Slice";
import _ from "lodash";
import saerchfileds from "../../Assets/AppComponent/Vector (33).svg"
import { useNavigate } from "react-router-dom";
import boximg from "../../Assets/AppComponent/Group 427320177.svg";
import Filterimg from "../../Assets/AppComponent/Vector (40).svg";
import { toast } from "react-toastify";


const InternalTable = (props) => {
    const { activeButton, setActiveButton ,
          datas,
  PriorityValues,
  SttausValues,
  Client,
  date,
  range,
  Client_id
     } = props
    const [selectedTab, setSelectedTab] = useState(activeButton);
    const [searchQuery, setSearchQuery] = useState('');
    const dispatch = useDispatch();
    const state = useSelector((state) => state)
    const priorityOptions = [
        { value: "", label: "All" },
        { value: "0", label: "Low" },
        { value: "1", label: "Medium" },
        { value: "2", label: "High" },
    ];

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState("");
    const [tempOption, setTempOption] = useState("");
    const popupRef = useRef(null);
const [pageIndex, setPageIndex] = useState(1);      // current page number
const [dtpageindex, setDtPageIndex] = useState(1);  // use if needed separately
const [goPage, setGoPage] = useState(dtpageindex);           // Go-to-page input value


    const togglePopup = () => setIsOpen(!isOpen);

    const handleCheckboxChange = (isChecked, event, data, key) => {

        setlistofCheck({
            check1: key === 1 ? isChecked : false,
            check2: key === 2 ? isChecked : false,
            check3: key === 3 ? isChecked : false,
            check4: key === 4 ? isChecked : false,
        });
    
        setSelectedOptions(isChecked ? data : ""); // Only store the selected value
    };

  
   

    const navigate = useNavigate();
    const [listsodcheck, setlistofCheck] = useState({
        check1: false,
        check2: false,
        check3: false,
        check4: false,
        check5: false,
    });

    useEffect(() => {
        dispatch(settheTicketraiseroutes(0))
    }, [])

    let isValidRange =
  Array.isArray(range) &&
  range.length > 0 &&
  range.every((date) => !!date && date !== "NaN-aN-aN");



    useEffect(() => {
        const payload = {
            search: searchQuery,
            page_size: 20,
            page: dtpageindex,
            priority: selectedOptions,
            status: activeButton == "All" ? "" : activeButton == "Open" ?
                "0" : activeButton == "In Progress" ? "1" : activeButton == "Review" ? "2" : activeButton == "Resolved" ? "3" :
                    activeButton == "Reopen" ? "4" : activeButton == "Reject" && 5,
            ticket_assign: false,

                // state: datas?.state,
                // region: datas?.region,
                // zone: datas?.zone,
                // client: Client,
                department:Client,
from_date: range[0],
                to_date: range[1],
range: isValidRange,
date:date,

  // state:datas?.state,
  //   region:datas?.region,
  //   zone:datas?.zone,

  //   client:Client_id

        };
        dispatch(settheInternalTicketsystemrecordgetListInternalDepartmentsDataActions(payload));
        setIsOpen(false)
    }, [dtpageindex ,activeButton, searchQuery, selectedOptions ,date , Client ]);



    const statusTabs = ['All', 'Open', 'In Progress', 'Review', 'Rejected', 'Reopen', 'Resolved'];
    const formatedDateListwithouttime = (dateString) => {
        const date = new Date(dateString);

        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);
        return `${formattedDate}`;
    };
    function tochange(e) {
        debouncedSearch(e);

    }
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setSearchQuery(e);
            }, 500),
        []
    );
    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);
    const HandletheActived = (tab) => {
        props.HandletheActived(tab)
    }
    

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };
  

      const handleGotoPage = (e) => {
    e.preventDefault();
  };
  const GotoThePage = () => {
    const goPageNumber = Number(goPage);
 
    if (
      Math.ceil(
        props.datacount == null ? 1 : props.datacount / props.dtpagesize
      ) >= goPageNumber ||
      goPageNumber == ""
    ) {
        setPageIndex(goPageNumber);
    setDtPageIndex(goPageNumber);


    } else {
      toast.error("Invalid Page Number", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

 const handleNext = (newIndex) => {
  setPageIndex(newIndex);
  setDtPageIndex(newIndex);

};

const HandlePrevious = (newIndex) => {
  setPageIndex(newIndex);
  setDtPageIndex(newIndex);

};

    return (
        <div className="tickets-container" ref={popupRef}>
            <div className="tickets-header">
                <div className="tabs">
                    {statusTabs.map(tab => (
                        <button
                            key={tab}
                            className={`tab ${activeButton === tab ? 'active' : ''}`}
                            onClick={() => {
                                HandletheActived(tab)
                                setSelectedTab(tab);
                                setActiveButton(tab)
                            }}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
                <div className="TableFilterSearchedresults">
                    <div className="SearchFields">

                        <img src={saerchfileds} />
                        <input
                            type="text"
                            placeholder="Search..."
                            className="search-input"
                            // value={searchQuery}
                            onChange={(e) => tochange(e.target.value)}
                        />


                    </div>
                    <div className="TableFilterofBoxs">
                        <img src={Filterimg} alt="Filter" onClick={togglePopup} style={{ cursor: "pointer" }} />

                    

                        {isOpen == true ? (
                            <div className="col-2 Subjectpopup">
                                <div className="SubjectBox">
                                    <ul class="list-group ">
                                        <li className={` list-group-item `}>
                                            All
                                            <input
                                                type="checkbox"
                                                className="form-controls"
                                                checked={listsodcheck.check1}
                                                name="check1"
                                                onChange={(e) => {
                                                    handleCheckboxChange(
                                                        !listsodcheck.check1,
                                                        e,
                                                        "",
                                                        1
                                                    );
                                                }}
                                            />
                                        </li>
                                        <li className={` list-group-item `}>
                                            Low
                                            <input
                                                type="checkbox"
                                                className="form-controls"
                                                checked={listsodcheck.check2}
                                                name="check2"
                                                onChange={(e) => {
                                                    handleCheckboxChange(
                                                        !listsodcheck.check2,
                                                        e,
                                                        "0",
                                                        2
                                                    );
                                                }}
                                            />
                                        </li>
                                        <li className={` list-group-item`}>
                                            Medium
                                            <input
                                                type="checkbox"
                                                className="form-controls"
                                                name="check3"
                                                checked={listsodcheck.check3}
                                                onChange={(e) => {
                                                    handleCheckboxChange(
                                                        !listsodcheck.check3,
                                                        e,
                                                        "1",
                                                        3
                                                    );
                                                }}
                                            />
                                        </li>
                                        <li className="list-group-item">
                                            High
                                            <input
                                                type="checkbox"
                                                className="form-controls"
                                                name="check4"
                                                checked={listsodcheck.check4}
                                                onChange={(e) => {
                                                    handleCheckboxChange(
                                                        !listsodcheck.check4,
                                                        e,
                                                        "2",

                                                        4
                                                    );
                                                }}
                                            />
                                        </li>

                                    </ul>
                                </div>
                            </div>
                        ) : null}



                    </div>
                </div>
            </div>



      <div className="InnerTable_customs">

      <table className="tickets-table">
                <thead>
                    <tr>
                        <th>Created</th>
                        <th>Category</th>
                        <th>Subcategory</th>
                        <th>Description</th>
                        <th>Status</th>
                        <th>Priority</th>
                    </tr>
                </thead>
                <tbody>
                    {state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData.length > 0 ?
                        <>
                            {state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData.map((ticket, index) => (

                                <tr key={index}>

                                    <td>{formatedDateListwithouttime(ticket.created_at)}</td>
                                    <td>{ticket.internal_category_id?.issue_category_id?.name ? ticket.internal_category_id?.issue_category_id?.name : "--"}</td>
                                    <td>{ticket.internal_category_id?.name ? ticket.internal_category_id?.name : "--"}</td>

                                    <td>{truncateText(ticket.remarks, 50)}</td>

                                    <td>

                                        <span className="status-badge"
                                            style={{
                                                background: ticket?.status == 0 ? "#FFDDDD" : // Open - light background
                                                    ticket?.status == 1 ? "#FFF8E5" : // In Progress - yellow background
                                                        ticket?.status == 2 ? "#E7F8ED" : // Completed - light green background
                                                            ticket?.status == 3 ? "#DFFFE3" : // Close - light green background for Close
                                                                ticket?.status == 4 ? "#FFDDDD" : ticket?.status == 5 && "#FFDDDD", // Default for Reopen - light red background
                                                color: ticket?.status == 0 ? "#ED4C28" : // Open - red text
                                                    ticket?.status == 1 ? "#FFB800" : // In Progress - yellow text
                                                        ticket?.status == 2 ? "#12B749" : // Completed - green text
                                                            ticket?.status == 3 ? "#8BC34A" : // Close - light green text for Close
                                                                ticket?.status == 4 ? "#ED4C28" : ticket?.status == 5 && "#ED4C28", // Default for Reopen - red text
                                            }}

                                        >
                                            {ticket.status == 0
                                                ? "Open"
                                                : ticket.status == 1
                                                    ? "In Progress"
                                                    : ticket.status == 2
                                                        ? "Review"
                                                        : ticket.status == 3
                                                            ? "Resolved"
                                                            : ticket.status == 4 ? "Reopened" :
                                                                ticket.status == 5 && "Reject"}
                                        </span>
                                    </td>
                                    <td>
                                        <span className={`priority-badge ${ticket.priority == "0" ?
                                            "low" :
                                            ticket.priority == "1" ?
                                                "medium" :
                                                ticket.priority == "2" && "high"

                                            }`}>

                                            {ticket?.priority === "0" || ticket?.priority === "1" || ticket?.priority === "2" ? (
                                                <>
                                                    {ticket?.priority === "0" ? "Low" : ticket?.priority === "1" ? "Medium" : "High"}
                                                </>
                                            ) : (
                                                "---"
                                            )}

                                        </span>
                                    </td>
                                </tr>
                            ))}
                        </>
                        :
                        null

                    }
                </tbody>
            </table>


                {state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData != undefined &&
                state.TrackingrecordgetOfSystemListInternalDepartment.TrackingrecordgetInternalDepartmentsListOfSystemData.length > 0 ?
                <>
                </>
                : <>
                    <div>

                        <div className="Dusbinbacktabls">

                            <div>
                                <img src={boximg} />
                                <p className="text-center">
                                    {"No Data Tickets Available"}
                                </p>

                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
        

            <div className="view-all">
      {state.TrackingrecordgetOfSystemListInternalDepartment.Total_Count > 20 ? (
                      <div
                        className="pagination"
                        style={{ justifyContent: "end", width: "100%" }}
                      >
                        <div
                          className=" pagination"
                          style={{ justifyContent: "end" }}
                        >
                          <div className="showrow1" style={{ padding: "4px" }}>

                            <button
                              className="btn btn prim"
                              style={{ border: "none" }}
                              onClick={() => {
                                HandlePrevious(dtpageindex - 1);
                                // previousPage();
                                if (props.id == "spe" || props.id == "sym") {
                                  props.setsno(props.sno - 20);
                                }
                              }}
                              disabled={pageIndex == 1}
                            >
                              {"<"}
                            </button>
                            <span style={{ padding: "10px" }}>


                              <strong style={{ fontSize: "12px" }}>

                                {pageIndex} of{" "}
                                {Math.ceil(
                                  state.TrackingrecordgetOfSystemListInternalDepartment.Total_Count == null
                                    ? 1
                                    : state.TrackingrecordgetOfSystemListInternalDepartment.Total_Count / props.dtpagesize
                                )}{" "}
                              </strong>
                            </span>

                            <button
                              style={{ border: "none" }}
                              className="btn btn prim"
                              onClick={() => {
                           
                                handleNext(dtpageindex + 1);

                              }}
                              disabled={
                                pageIndex ==
                                Math.ceil(state.TrackingrecordgetOfSystemListInternalDepartment.Total_Count / props.dtpagesize)
                              }
                            >
                              {">"}
                            </button>

                            <span className="GOTOPageOuters">
                              <form
                                className="GotoPageForm"
                                onSubmit={handleGotoPage}
                              >
                                <span className="GotoPageText">Go to Page</span>
                                <input
                                  type="number"
                                  value={goPage}
                                  className="formcontrol_Table"
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    const newPageIndex = e.target.value;
                                    console.log(
                                      newPageIndex,
                                      "newPageIndex",
                                      !isNaN(newPageIndex)
                                    );

                                    if (!isNaN(newPageIndex)) {
                                      // if (
                                      //   props.id === "spe" ||
                                      //   props.id === "sym"
                                      // ) {
                                      //   props.setsno((newPageIndex - 1) * 20);
                                      // }
                                      if (
                                        newPageIndex != 0 &&
                                        newPageIndex > 0
                                      ) {
                                        setGoPage(newPageIndex);
                                      } else if (
                                        newPageIndex == 0 ||
                                        newPageIndex < 0
                                      ) {
                                        setGoPage("");
                                      }
                                    }
                                  }}
                                  step="1"
                                  onKeyDown={(evt) => {
                                    if (
                                      ["e", "E", "+", "-", "."].includes(
                                        evt.key
                                      )
                                    ) {
                                      evt.preventDefault();
                                    }
                                  }}
                                />

                                <button
                                  type="submit"
                                  className="GOBTON btn"
                                  disabled={goPage == ""}
                                  onClick={(e) => {
                                    GotoThePage();
                                  }}
                                >
                                  Go
                                </button>
                              </form>
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

            </div>
        </div>
    );
};

export default InternalTable;